import axios from "../helper/AxiosHelper";
import ApiHelper from "./ApiHelper";



const getTopSkillParticipantCount = async (orgType) => {

  // const data = {};
  if (orgType != null && orgType !== undefined) {
    orgType = orgType.trim();
  } else {
    orgType = "";
  }


  const response = await axios.get(`/passport/getTopSkillParticipantCount?org_type=${orgType}`);

  return ApiHelper.processResponse(response);
};

// getTopMemberPlayTimeWithOrgSkill?org_id=145&skill_code=hoshun_karate
const getTopMemberPlayTimeWithOrgSkill = async (orgID, skillCode, orgType) => {
  if (orgType == null || orgType === undefined) {
    orgType = "";
  }

  const url = `/passport/getTopMemberPlayTimeWithOrgSkill?org_id=${orgID}&skill_code=${skillCode}&org_type=${orgType}`;
  const response = await axios.get(url);

  return ApiHelper.processResponse(response);
}


const getTopOrgPlayTime = async (orgType) => {
  const orgTypeParam = orgType ? `?org_type=${orgType}` : '';

  const response = await axios.get(`/passport/getTopOrgPlayTime${orgTypeParam}`);

  return ApiHelper.processResponse(response);
}



export const LeaderboardApi = {
  getTopMemberPlayTimeWithOrgSkill,
  getTopOrgPlayTime,
  getTopSkillParticipantCount,
};
